import React from "react";
import { useSelector } from "react-redux";
import { getFirstChar } from "../../../../helpers/common";

const QualificationJourney = ({
  handleOpenQualificationModal,
  componentType = "overview",
}) => {
  const { qualifications } = useSelector((state) => state.customer);

  const getCollegeAndYear = (additionalFields) => {
    let collegeAndYear = "";

    const hasYearAdded =
      additionalFields?.start_year && additionalFields?.end_year;

    if (additionalFields?.university_college) {
      collegeAndYear += `${additionalFields?.university_college} ${
        hasYearAdded ? "-" : ""
      } `;
    }

    if (hasYearAdded) {
      collegeAndYear += `(${additionalFields?.start_year} - ${additionalFields?.end_year})`;
    }

    return collegeAndYear;
  };

  return (
    <>
      {qualifications && qualifications?.length > 0 ? (
        qualifications?.map((item) => {
          const additionalFields = item?.additional_fields;
          return (
            <div
              key={item?.id}
              className='candidate-education-content mt-4 d-flex'
            >
              <div className='circle flex-shrink-0 bg-soft-primary'>
                {getFirstChar(additionalFields?.title)}
              </div>
              <div className='ms-4'>
                <div className='d-flex'>
                  <h6 className='fs-16 mb-1 me-3'>{additionalFields?.title}</h6>

                  {componentType === "update" ? (
                    <div
                      className='cursor-pointer'
                      onClick={() =>
                        handleOpenQualificationModal("update", item)
                      }
                    >
                      <i className='uil uil-edit'></i>
                    </div>
                  ) : null}
                </div>
                <p className='mb-2 text-muted'>
                  {getCollegeAndYear(additionalFields)}
                </p>
                <p className='text-muted'>{additionalFields?.details}</p>
                {additionalFields?.certification && (
                  <p className='text-muted'>
                    <b>Certification:</b> {additionalFields?.certification}
                  </p>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <>
          <p className='mt-4 mb-5'>
            No qualification information has been added.
          </p>
        </>
      )}
    </>
  );
};

export default QualificationJourney;
